import HeroMona, {type HeroMonaOptions} from '../../../WebGLHero/webgl/mona/hero-mona'

const FOOTER_OPTIONS: HeroMonaOptions = {
  positionX: 0,
  rotationY: 0,
  scale: 0.65,
  startOpeningOnLoad: false,
}

export default class FooterHeroMona extends HeroMona {
  constructor(reduceMotion: boolean, onError?: (error: unknown) => void, onOpeningComplete?: () => void) {
    super({reduceMotion, options: FOOTER_OPTIONS, onError, onOpeningComplete})
  }
}
